module.exports = __webpack_public_path__ + "img/UTDEER-6.93340846.jpg";